module.exports = __webpack_public_path__ + "assets/img/analysisRole2.6ede984a.png";